<template>
  <!-- eslint-disable vue/no-lone-template -->
  <div class="nav-bar-wrapper">
    <template v-if="isRuejaiPartnerAdmin">
      <div class="title mt-3">{{ "ใบแจ้งหนี้" }}</div>
      <li class="divider"></li>
      <ul>
        <router-link
          :key="'invoice'"
          v-slot="{ navigate, isActive }"
          :to="{
            name: 'SupplierInvoiceDashboard',
            query: { status: 'in_progress' },
          }"
          active-class="active"
          custom
        >
          <li
            :class="{ active: isActive }"
            class="item pointer"
            @click="navigateMenu(navigate, $event)"
          >
            <div>
              <img
                src="/static/icons/supplier-icon/navigation-created-icon.svg"
              />
              {{ "ใบแจ้งหนี้" }}
            </div>
          </li>
        </router-link>
      </ul>
      <li class="divider"></li>
      <li class="mt-3"></li>
      <ul>
        <li
          :class="!isDesktop ? 'last-item' : ''"
          class="item pointer"
          @click="showLogoutMenu"
        >
          <img src="/static/icons/supplier-icon/navigation-logout-icon.svg" />
          {{ "ออกจากระบบ" }}
        </li>
      </ul>
    </template>

    <template v-else>
      <div class="title">{{ "จัดการงาน" }}</div>
      <li class="divider"></li>
      <ul>
        <router-link
          :key="'newAppoint'"
          v-slot="{ navigate, isActive }"
          :to="{
            name: 'SupplierJobList',
            params: { navigationMenu: navigationMenu.NEW },
          }"
          active-class="active"
          custom
        >
          <li
            :class="{ active: isActive }"
            class="item pointer"
            @click="navigateMenu(navigate, $event)"
          >
            <div>
              <img
                src="/static/icons/supplier-icon/navigation-created-icon.svg"
              />
              {{ "รอยืนยัน" }}
            </div>
          </li>
        </router-link>
      </ul>
      <li class="divider"></li>
      <ul>
        <router-link
          :key="'inProgress'"
          v-slot="{ navigate, isActive }"
          :to="{
            name: 'SupplierJobList',
            params: { navigationMenu: navigationMenu.PENDING },
          }"
          active-class="active"
          custom
        >
          <li
            :class="{ active: isActive }"
            class="item pointer"
            @click="navigateMenu(navigate, $event)"
          >
            <div>
              <img
                src="/static/icons/supplier-icon/navigation-confirmed-icon.svg"
              />
              {{ "ยืนยันแล้ว/รอดำเนินการ" }}
            </div>
          </li>
        </router-link>
      </ul>
      <li class="divider"></li>
      <ul>
        <router-link
          :key="'finished'"
          v-slot="{ navigate, isActive }"
          :to="{
            name: 'SupplierJobList',
            params: { navigationMenu: navigationMenu.FINISHED },
          }"
          active-class="active"
          custom
        >
          <li
            :class="{ active: isActive }"
            class="item pointer"
            @click="navigateMenu(navigate, $event)"
          >
            <div>
              <img
                src="/static/icons/supplier-icon/navigation-fulfilled-icon.svg"
              />
              {{ "ปิดงานแล้ว" }}
            </div>
          </li>
        </router-link>
      </ul>
      <li class="divider"></li>
      <ul>
        <router-link
          :key="'report'"
          v-slot="{ navigate, isActive }"
          :to="{
            name: 'SupplierReportList',
            params: { navigationMenu: navigationMenu.REPORT },
          }"
          active-class="active"
          custom
        >
          <li
            :class="{ active: isActive }"
            class="item pointer"
            @click="navigateMenu(navigate, $event)"
          >
            <div>
              <img
                src="/static/icons/supplier-icon/navigation-report-icon.svg"
              />
              {{ "รายงานการให้บริการ" }}
            </div>
          </li>
        </router-link>
      </ul>
      <li class="divider"></li>
      <div class="title mt-3">{{ "ใบแจ้งหนี้" }}</div>
      <li class="divider"></li>
      <ul>
        <router-link
          :key="'invoice'"
          v-slot="{ navigate, isActive }"
          :to="{
            name: 'SupplierInvoiceDashboard',
            query: { status: 'un_billed' },
          }"
          active-class="active"
          custom
        >
          <li
            :class="{ active: isActive }"
            class="item pointer"
            @click="navigateMenu(navigate, $event)"
          >
            <div>
              <img
                src="/static/icons/supplier-icon/navigation-created-icon.svg"
              />
              {{ "ใบแจ้งหนี้" }}
            </div>
          </li>
        </router-link>
      </ul>
      <li class="divider"></li>
      <li class="mt-3"></li>
      <ul>
        <li
          :class="!isDesktop ? 'last-item' : ''"
          class="item pointer"
          @click="showLogoutMenu"
        >
          <img src="/static/icons/supplier-icon/navigation-logout-icon.svg" />
          {{ "ออกจากระบบ" }}
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import { mSize } from "../StaticVariable"
import { navigationMenu, permissionRole } from "../../lib/mapper"

export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      roleId: parseInt(localStorage.getItem("supplierRoleId"), 10),
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= mSize
    },
    navigationMenu() {
      return navigationMenu
    },
    isRuejaiPartnerAdmin() {
      return this.roleId === permissionRole.RJPADMIN
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
    hideMobileNavBar() {
      this.$emit("hideMobileNavBar")
    },
    navigateMenu(navigate, event) {
      this.hideMobileNavBar()
      navigate(event)
    },
    showLogoutMenu() {
      this.$emit("showLogoutMenu")
    },
    async logout(action) {
      if (action) {
        try {
          baanRueJaiClient.setAuthorizationToken()
        } catch (error) {
          // eslint-disable-next-line no-console
          console.debug(error)
        }

        localStorage.clear()
        this.$router.push({ name: "SupplierLogin" })
      } else {
        this.showLogoutDialog = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.nav-bar-wrapper {
  .title {
    padding: 16px;
    font-size: $font-16;
    font-weight: bold;
    color: $supplier-primary-color;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style-type: none;

    li {
      padding: 16px;
    }

    > .item {
      color: $black;
      font-size: $font-16;
      border-left: 4px solid transparent;
      padding-left: 16px;

      &:hover {
        background-color: #f7f7f7;
        text-decoration: none;
        color: $black;
      }

      &.active,
      &:focus {
        background-color: #f7f7f7;
        text-decoration: none;
        font-weight: bold;
      }
      &.active {
        border-left: 4px solid $supplier-primary-color;
      }

      img {
        margin-right: 16px;
      }
    }
  }

  > .divider {
    margin-inline: 24px;
    margin-block: 2px;
    border-bottom: 1px solid $color-light-gray-1;
  }
}

@media (max-width: ($m-size - 1)) {
  .nav-bar-wrapper {
    ul {
      li {
        padding: 12px;
      }

      > .item {
        padding-left: 12px;

        img {
          width: 20px;
          height: 20px;
          margin-right: 12px;
        }
      }
    }

    > .divider {
      margin-inline: 16px;
    }
  }

  .last-item {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .nav-bar-wrapper {
    ul {
      li {
        padding: 12px 4px;
      }

      > .item {
        font-size: $font-14;
        padding-left: 4px;

        img {
          width: 20px;
          height: 20px;
          margin-right: 6px;
        }
      }
    }

    > .divider {
      margin-inline: 12px;
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .nav-bar-wrapper {
    ul {
      li {
        padding: 16px 8px;
      }

      > .item {
        font-size: $font-14;
        padding-left: 8px;

        img {
          width: 22px;
          height: 22px;
          margin-right: 12px;
        }
      }
    }

    > .divider {
      margin-inline: 12px;
    }
  }
}
</style>
